import firebase from 'firebase/app';
import 'firebaseui/dist/firebaseui.css';

// apiKey: 'AIzaSyA9i-w1kDCwtn579e9TDwJ5RoAMum32tnw',
// 	authDomain: 'sborovy-web.firebaseapp.com',
// 	databaseURL: 'https://sborovy-web.firebaseio.com',
// 	projectId: 'sborovy-web',
// 	storageBucket: 'sborovy-web.appspot.com',
// 	messagingSenderId: '40417737531',
// 	appId: '1:40417737531:web:c70073bde6ca620545951e'
const prodConfig = {
	apiKey: 'AIzaSyA9i-w1kDCwtn579e9TDwJ5RoAMum32tnw',
	authDomain: 'sborovy-web.firebaseapp.com',
	databaseURL: 'https://sborovy-web.firebaseio.com',
	projectId: 'sborovy-web',
	storageBucket: 'sborovy-web.appspot.com',
	messagingSenderId: '40417737531',
};

// const devConfig = {
// 	apiKey: 'AIzaSyC4V7hloyF6yUsdmM8IP26AWuPB-rg7sn4',
// 	authDomain: 'horni-pocernice.firebaseapp.com',
// 	databaseURL: 'https://horni-pocernice.firebaseio.com',
// 	projectId: 'horni-pocernice',
// 	storageBucket: 'horni-pocernice.appspot.com',
// 	messagingSenderId: '795678567124'
// };

const firebaseConfig = process.env.NODE_ENV !== 'production' ? prodConfig : prodConfig;


const firebaseUIConfig = {
	signInFlow: 'popup',
	signInSuccessUrl: './',
	signInOptions: [
		firebase.auth.GoogleAuthProvider.PROVIDER_ID
	],
	// tosUrl: "./tos",
	// privacyPolicyUrl: "./privacy"
};

export { firebaseConfig, firebaseUIConfig };
